import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { IconButton, Typography } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { callApi } from '../../services/api.service';
import { useDataAuth } from '../../hooks/useDataAuth';


export const NavbarNavigationResolver = ({ id_user_action = "MENU-CUSTOMER-REQUEST_USER", isMobileScreen = false }) => {
    const [{ userSession }] = useDataAuth();
    const navigate = useNavigate();
    const [conf, setconf] = useState(null);

    const handleClick = (item) => {
        if (item)
            navigate(item.path, { state: { config: item } });
    };

    useEffect(() => {
        const getMenuId = async () => {
            try {
                const response = await callApi("user_select", "MENU_ID", { id_user_action }, userSession.token, { findOne: 'true' });
                if (response.status === 200) {
                    setconf(response.data);
                }
            } catch (err) {
                console.error('Error:', err);
            }
        };
        getMenuId();
    }, [id_user_action, userSession.token])

    const handleReiredt = () => handleClick(conf);

    return (
        <>
            <Typography
                sx={{
                    color: isMobileScreen ? '#ffffff' : (theme) => theme.navbar.text
                }}
            >
                Soporte
            </Typography>

            <IconButton
                color="inherit"
                aria-label="support"
                onClick={handleReiredt}
                edge="center"
            >
                <SupportAgentIcon color="primary" />
            </IconButton>
        </>
    )
}
